module.exports = __webpack_public_path__ + "img/SalaryInquiries.41864f71.svg";